export const WithdrawIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6693 4.66667H15.3359V11.3333H14.6693V13.3333C14.6693 13.7015 14.3708 14 14.0026 14H2.0026C1.63442 14 1.33594 13.7015 1.33594 13.3333V2.66667C1.33594 2.29847 1.63442 2 2.0026 2H14.0026C14.3708 2 14.6693 2.29847 14.6693 2.66667V4.66667ZM13.3359 11.3333H9.33595C7.49502 11.3333 6.0026 9.84094 6.0026 8.00001C6.0026 6.15905 7.49502 4.66667 9.33595 4.66667H13.3359V3.33333H2.66927V12.6667H13.3359V11.3333ZM14.0026 10V6H9.33595C8.23135 6 7.33595 6.89541 7.33595 8.00001C7.33595 9.10454 8.23135 10 9.33595 10H14.0026ZM9.33595 7.33334H11.3359V8.66667H9.33595V7.33334Z"
        fill="currentColor"
      />
    </svg>
  );
};
